import { render, staticRenderFns } from "./RequestDetailsCard.vue?vue&type=template&id=3d406b13"
import script from "./RequestDetailsCard.vue?vue&type=script&lang=js"
export * from "./RequestDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports